import axios from 'axios';
import { useEffect, useState } from 'react';
import { baseUrl_ } from '../../utils/constants';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {
  useDiable2faMutation,
  useEnable2faMutation,
} from '../../features/2FAenable/2FAenableSlice';
import Button from '../global/Button';
import Modal from '../Modal';
import locker from '../../assets/icons/locker.svg';
import successLocker from '../../assets/icons/successLocker.svg';
import customToast, { ToastType } from '../../components_/Toast';

const TwoFactorToggler = ({ is2faEnabled }: any) => {
  //   const stored2faEnabled = localStorage.getItem('2fa-enabled');
  //   const initialIsToggled = stored2faEnabled
  //     ? JSON.parse(stored2faEnabled)
  //     : JSON.parse(is2faEnabled);
  const [isToggled, setIsToggled] = useState<boolean>(is2faEnabled);
  const token: string | null = localStorage.getItem('login-token');
  const [showEnable2fa, setShowEnable2fa] = useState(false);
  const [showDisable2fa, setShowDisable2fa] = useState(false);

  const navigate = useNavigate();

  const refreshPage = () => {
    navigate(0);
  };

  const handleToggle = () => {
    if (isToggled) {
      setShowDisable2fa(true);
    } else {
      setShowEnable2fa(true);
    }
  };
  const [enable2fa, { isLoading: isUpdating, isSuccess }] = useEnable2faMutation();
  const [diable2fa, { isLoading: isDisabling, isSuccess: success }] = useDiable2faMutation();

  const active2Fa = async () => {
    try {
      await enable2fa({ token });
      customToast('2FA successfully enabled.', ToastType.success);
      localStorage.setItem('2fa-enabled', JSON.stringify(!isToggled)); // Update localStorage
    } catch (err) {
      customToast('Failed to enable 2FA', ToastType.error);
    }
  };

  const disabled2fa = async () => {
    try {
      await diable2fa({ token });
      customToast('2FA successfully disabled.', ToastType.success);
      localStorage.setItem('2fa-enabled', JSON.stringify(!isToggled)); // Update localStorage
    } catch (err) {
      customToast('Failed to disable 2FA', ToastType.error);
    }
  };

  useEffect(() => {
    localStorage.setItem('2fa-enabled', JSON.stringify(isToggled));
  }, [isToggled]);

  return (
    <>
      <div className={`${isDisabling || isUpdating ? 'disabled' : ''}`}>
        <label className='switch'>
          <input
            type='checkbox'
            disabled={isDisabling || isUpdating}
            checked={isToggled}
            onChange={handleToggle}
          />
          <span className='slider round'></span>
        </label>
      </div>
      <Modal
        show={showEnable2fa}
        onRequestClose={() => setShowEnable2fa(false)}
        className='!w-[460px]  pt-[50px] pb-[57px] px-[40px]'
      >
        {showEnable2fa && !isSuccess && (
          <>
            <div className='flex justify-center'>
              <img src={locker} alt='locker' />
            </div>
            <div className='text-center'>
              <h2 className='text-[#028789] font-Poppins text-[32px] pb-[18px] font-semibold'>
                Enable 2FA?
              </h2>
              <p className='font-Poppins text-[15px] text-black font-normal'>
                You will be required to authenticate every login using the six-digit OTP that will
                be sent to your registered email address. Proceed?
              </p>
            </div>
            <div className='flex justify-between gap-x-6 pt-[40px]'>
              <Button
                type='button'
                size='sm'
                // loading={loading}
                onClick={() => {
                  setIsToggled(!isToggled);
                  active2Fa();
                }}
                className='text-sm w-full xl:text-lg font-bold font-Poppins  '
              >
                YES
              </Button>
              <Button
                type='button'
                size='sm'
                onClick={() => setShowEnable2fa(false)}
                className='text-sm w-full xl:text-lg font-bold font-Poppins !bg-white  border-green border !text-green'
              >
                NO
              </Button>
            </div>
          </>
        )}
        {isSuccess && (
          <>
            <div className='flex justify-center'>
              <img src={successLocker} alt='locker' />
            </div>
            <div className='text-center'>
              <h2 className='text-[#028789] font-Poppins text-[32px] pb-[18px] font-semibold'>
                Success!{' '}
              </h2>
              <p className='font-Poppins text-[15px] text-black font-normal'>
                2FA enabled successfully.
              </p>
            </div>
            <div className='flex justify-between gap-x-6 pt-[40px]'>
              <Button
                type='button'
                size='sm'
                onClick={() => {
                  setShowEnable2fa(false);
                  setShowDisable2fa(false);
                  refreshPage();
                }}
                className='text-sm w-[274px] mx-auto xl:text-lg font-bold font-Poppins '
              >
                CLOSE
              </Button>
            </div>
          </>
        )}
      </Modal>
      <Modal
        show={showDisable2fa}
        onRequestClose={() => setShowDisable2fa(false)}
        className='!w-[460px]  pt-[50px] pb-[57px] px-[40px]'
      >
        {showDisable2fa && !success && (
          <>
            <div className='flex justify-center'>
              <img src={locker} alt='locker' />
            </div>
            <div className='text-center'>
              <h2 className='text-[#028789] font-Poppins text-[32px] pb-[18px] font-semibold'>
                Disable 2FA?
              </h2>
              <p className='font-Poppins text-[15px] text-black font-normal'>
                You will only be required to log in using your email address and password making it
                less secure. Proceed?
              </p>
            </div>
            <div className='flex justify-between gap-x-6 pt-[40px]'>
              <Button
                type='button'
                size='sm'
                // loading={loading}
                onClick={() => {
                  setIsToggled(!isToggled);
                  disabled2fa();
                }}
                className='text-sm w-full xl:text-lg font-bold font-Poppins  '
              >
                YES
              </Button>
              <Button
                type='button'
                size='sm'
                onClick={() => setShowDisable2fa(false)}
                className='text-sm w-full xl:text-lg font-bold font-Poppins !bg-white  border-green border !text-green'
              >
                NO
              </Button>
            </div>
          </>
        )}
        {success && (
          <>
            <div className='flex justify-center'>
              <img src={successLocker} alt='locker' />
            </div>
            <div className='text-center'>
              <h2 className='text-[#028789] font-Poppins text-[32px] pb-[18px] font-semibold'>
                Success!{' '}
              </h2>
              <p className='font-Poppins text-[15px] text-black font-normal'>
                2FA disabled successfully. Extra layer of security removed from your profile
              </p>
            </div>
            <div className='flex justify-between gap-x-6 pt-[40px]'>
              <Button
                type='button'
                size='sm'
                onClick={() => {
                  setShowEnable2fa(false);
                  setShowDisable2fa(false);
                  refreshPage();
                }}
                className='text-sm w-[274px] mx-auto xl:text-lg font-bold font-Poppins '
              >
                CLOSE
              </Button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default TwoFactorToggler;
